import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function QuotePage() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    product: '',
    quantity: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5i0ntjgekujqjrtsrr0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          product: '',
          quantity: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white pt-16 sm:pt-20">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-navy via-teal to-navy py-16 sm:py-20 lg:py-24">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="container mx-auto px-4 sm:px-6 relative z-10">
            <div className="max-w-3xl mx-auto text-center text-white">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">Teklif Alın</h1>
              <p className="text-base sm:text-lg lg:text-xl text-white/90 px-4">
                Ambalaj ihtiyaçlarınız için hemen teklif talep edin. Uzman ekibimiz en kısa sürede size dönüş yapacaktır.
              </p>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="py-12 sm:py-16 lg:py-20">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl lg:rounded-2xl shadow-xl border border-gray-100 p-6 sm:p-8 lg:p-10">
                <div className="mb-6 sm:mb-8">
                  <h2 className="text-2xl sm:text-3xl font-bold text-navy mb-2 sm:mb-3">Teklif Talep Formu</h2>
                  <p className="text-gray-600 text-sm sm:text-base">
                    Lütfen aşağıdaki formu eksiksiz doldurun. Size en uygun teklifi hazırlayalım.
                  </p>
                </div>

                <form 
                  id="quote-form" 
                  data-readdy-form 
                  onSubmit={handleSubmit}
                  className="space-y-4 sm:space-y-6"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    {/* Ad Soyad */}
                    <div>
                      <label htmlFor="name" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        Ad Soyad *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm"
                        placeholder="Adınız ve soyadınız"
                      />
                    </div>

                    {/* Firma Adı */}
                    <div>
                      <label htmlFor="company" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        Firma Adı *
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm"
                        placeholder="Firma adınız"
                      />
                    </div>

                    {/* E-posta */}
                    <div>
                      <label htmlFor="email" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        E-posta Adresi *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm"
                        placeholder="ornek@firma.com"
                      />
                    </div>

                    {/* Telefon */}
                    <div>
                      <label htmlFor="phone" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        Telefon *
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm"
                        placeholder="+90 5XX XXX XX XX"
                      />
                    </div>

                    {/* Ürün Seçimi */}
                    <div>
                      <label htmlFor="product" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        Ürün Kategorisi *
                      </label>
                      <select
                        id="product"
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm cursor-pointer"
                      >
                        <option value="">Ürün seçiniz</option>
                        <option value="PET Şişe">PET Şişe</option>
                        <option value="PET Kavanoz">PET Kavanoz</option>
                        <option value="PET Preform">PET Preform</option>
                        <option value="PP Kapak">PP Kapak</option>
                        <option value="Karma Ürünler">Karma Ürünler</option>
                      </select>
                    </div>

                    {/* Miktar */}
                    <div>
                      <label htmlFor="quantity" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                        Tahmini Miktar *
                      </label>
                      <input
                        type="text"
                        id="quantity"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm"
                        placeholder="Örn: 10.000 adet"
                      />
                    </div>
                  </div>

                  {/* Mesaj */}
                  <div>
                    <label htmlFor="message" className="block text-xs sm:text-sm font-semibold text-navy mb-2">
                      Ek Bilgiler ve Talepleriniz
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      maxLength={500}
                      rows={5}
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green focus:border-transparent transition-all text-sm resize-none"
                      placeholder="Ürün özellikleri, teslimat süresi, özel talepleriniz vb. (Maksimum 500 karakter)"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">
                      {formData.message.length}/500 karakter
                    </p>
                  </div>

                  {/* Submit Button */}
                  <div className="pt-4">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-green hover:bg-green/90 text-white font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-lg transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer text-sm sm:text-base"
                    >
                      {isSubmitting ? 'Gönderiliyor...' : 'Teklif Talebini Gönder'}
                    </button>
                  </div>

                  {/* Status Messages */}
                  {submitStatus === 'success' && (
                    <div className="bg-green/10 border border-green text-green px-4 sm:px-6 py-3 sm:py-4 rounded-lg">
                      <div className="flex items-center gap-3">
                        <i className="ri-checkbox-circle-fill text-xl sm:text-2xl"></i>
                        <div>
                          <p className="font-semibold text-sm sm:text-base">Talebiniz başarıyla gönderildi!</p>
                          <p className="text-xs sm:text-sm">En kısa sürede size dönüş yapacağız.</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-50 border border-red-300 text-red-700 px-4 sm:px-6 py-3 sm:py-4 rounded-lg">
                      <div className="flex items-center gap-3">
                        <i className="ri-error-warning-fill text-xl sm:text-2xl"></i>
                        <div>
                          <p className="font-semibold text-sm sm:text-base">Bir hata oluştu!</p>
                          <p className="text-xs sm:text-sm">Lütfen daha sonra tekrar deneyin.</p>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>

              {/* Info Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
                <div className="bg-gradient-to-br from-navy to-teal p-5 sm:p-6 rounded-xl text-white">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                    <i className="ri-time-line text-xl sm:text-2xl"></i>
                  </div>
                  <h3 className="font-bold text-base sm:text-lg mb-2">Hızlı Dönüş</h3>
                  <p className="text-xs sm:text-sm text-white/80">
                    Teklif taleplerinize 24 saat içinde yanıt veriyoruz.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal to-green p-5 sm:p-6 rounded-xl text-white">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                    <i className="ri-shield-check-line text-xl sm:text-2xl"></i>
                  </div>
                  <h3 className="font-bold text-base sm:text-lg mb-2">Güvenilir Hizmet</h3>
                  <p className="text-xs sm:text-sm text-white/80">
                    Kaliteli ürün ve zamanında teslimat garantisi.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-green to-navy p-5 sm:p-6 rounded-xl text-white">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                    <i className="ri-customer-service-2-line text-xl sm:text-2xl"></i>
                  </div>
                  <h3 className="font-bold text-base sm:text-lg mb-2">Uzman Destek</h3>
                  <p className="text-xs sm:text-sm text-white/80">
                    Deneyimli ekibimiz size en uygun çözümü sunar.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
